const defaultQueryValues: {[key: string]: string} = {
  column: 'filter_sort[sort_column]',
  direction: 'filter_sort[sort_direction]',
  beerStyleId: 'filter[beer_style][]',
};

interface IGetOptionalParamsObjectProps {
  search: {[key: string]: any};
  queryValues?: {[key: string]: string};
}

const getOptionalParams = ({search, queryValues = defaultQueryValues}: IGetOptionalParamsObjectProps) => {
  const queryObject: {[key: string]: string} = {};

  Object.keys(search).forEach((key) => {
    if (key in queryValues) {
      const queryObjKey = queryValues[key];

      queryObject[queryObjKey] = search[key];
    }
  });

  return queryObject;
};

export default getOptionalParams;
